'use client';

import { ExternalLink } from 'lucide-react';
import { NoticeAlert } from '../notice-alert';

interface PreviewWebsiteContentProps {
  title: string;
  description: string;
  previewImageUrl: string;
  className?: string;
  /** Optional warning rendered as an inline alert below the preview. */
  notice?: string | null;
}

/**
 * Renders a website preview card with image, title, and description.
 */
export function PreviewWebsiteContent({
  title,
  description,
  previewImageUrl,
  notice,
}: PreviewWebsiteContentProps) {
  return (
    <div className="flex w-full flex-col overflow-hidden rounded-2xl border border-border bg-background">
      <div className="flex w-full items-start">
        {/* Preview image */}
        <div className="w-[288px] shrink-0 py-4 pl-4">
          <div className="aspect-[288/176] overflow-hidden rounded-md">
            <img
              src={previewImageUrl}
              alt={title}
              className="size-full object-cover object-top"
            />
          </div>
        </div>

        {/* Content */}
        <div className="flex flex-1 flex-col items-start self-stretch p-4">
          <div className="flex flex-col items-start">
            <p className="text-base font-medium text-popover-foreground">
              {title}
            </p>
            <span className="flex items-center gap-1 text-sm text-primary">
              <ExternalLink className="size-3" />
              Preview
            </span>
            <p className="text-sm text-muted-foreground">{description}</p>
          </div>
        </div>
      </div>

      {/* Notice */}
      {notice && (
        <div className="px-4 pb-4">
          <NoticeAlert notice={notice} />
        </div>
      )}
    </div>
  );
}
